import { SortSelector } from "@components/common/sort-selector";
import { DEFAULT_GROUPS_SORT_BY, GROUPS_SORT_BY_MAP, GROUPS_SORT_OPTIONS } from "@components/groups/groups-constants";
import { getGroupsSortBy } from "@utils/group-utils";
import { GroupsSortBy } from "@custom-types/group-types";
import type { GroupsSortField } from "@custom-types/group-types";
import type { SortItem } from "@custom-types/sort-types";

interface Props {
  /** Current sort by value */
  sortBy: GroupsSortBy;

  /** Callback to update the sort by value */
  setSortBy: (sortBy: GroupsSortBy) => void;
}

/** Component to change the groups sort criteria for the tiles view */
export function GroupsSort({ sortBy, setSortBy }: Props): JSX.Element {
  // Fallback to default if sortBy is invalid
  const validSortBy = sortBy && GROUPS_SORT_BY_MAP[sortBy] ? sortBy : DEFAULT_GROUPS_SORT_BY;
  
  /* Handler for sort item change */
  function handleSortChange(newSortItem: SortItem<GroupsSortField>): void {
    const newSortBy = getGroupsSortBy(newSortItem);
    setSortBy(newSortBy);
  }
  
  return (
    <SortSelector
      sortOptions={GROUPS_SORT_OPTIONS}
      sortItem={GROUPS_SORT_BY_MAP[validSortBy]}
      setSortItem={handleSortChange}
      subjectType="Group"
    />
  );
}
